/**
 * contact.js — waar "Plan een gesprek" heen gaat.
 *
 * Eén adres voor alle gesprekslinks in de app (besluit Judith, 23 okt 2026):
 * het boekadres, niet meer de contactpagina van tof.services. Hier aanpassen,
 * dan verandert het overal — NL en EN gebruiken dezelfde link.
 */
export const BOOKING_URL = 'https://zeeg.me/judith-tof/30min';
